import { useEffect, useRef } from 'react';

const AudioPlayer = ({ audio, isPlaying = true, volume = 0.4 }) => {
    const audioRef = useRef(null);

    // Play or pause the audio when `isPlaying` changes
    useEffect(() => {
        if (audioRef.current) {
            // Set the volume
            audioRef.current.volume = volume;

            // Play the audio if `isPlaying` is true
            if (isPlaying) {
                audioRef.current.play().then(() => {
                    // Unmute the audio after a delay or on some user interaction.
                    setTimeout(() => {
                        // audioRef.current.muted = false;
                    }, 100);
                }).catch(error => {
                    console.log(error);
                    console.log('Autoplay is blocked');
                });
            } else {
                audioRef.current.pause();
            }
        }
    }, [isPlaying, volume]);

    return (
        <div>
            {/* Hidden Audio element */}
            <audio ref={audioRef} src={audio} className='hidden' loop />
        </div>
    );
};

export default AudioPlayer;
